/* SH menu drawer: opens and closes the sub-menu panels (layer 2).
   The theme's <sidebar-drawer> still opens and closes the drawer itself. */

if (typeof customElements.get('sh-menu-drawer') === 'undefined') {
  class ShMenuDrawer extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      this.main = this.querySelector('[data-sh-main]');
      this.addEventListener('click', this.onClick.bind(this));

      // Show the main menu again each time the drawer closes.
      this.drawer = this.closest('sidebar-drawer');
      if (this.drawer) {
        this.observer = new MutationObserver(() => {
          if (!this.drawer.classList.contains('active')) {
            clearTimeout(this.resetTimer);
            // Wait for the close animation, so the panel does not jump.
            this.resetTimer = setTimeout(() => this.showMain(false), 300);
          }
        });
        this.observer.observe(this.drawer, {attributes: true, attributeFilter: ['class']});
      }

      // Close the language list when a click lands outside it.
      this.onDocumentClick = (event) => {
        this.querySelectorAll('.sh-menu-lang__details[open]').forEach((details) => {
          if (!details.contains(event.target)) details.removeAttribute('open');
        });
      };
      document.addEventListener('click', this.onDocumentClick);
    }

    disconnectedCallback() {
      // The theme moves the drawer to <body>; only clean up when it is really removed.
      if (this.isConnected) return;
      this.observer?.disconnect();
      document.removeEventListener('click', this.onDocumentClick);
      this.ready = false;
    }

    /** @param {MouseEvent} event */
    onClick(event) {
      const target = /** @type {HTMLElement} */ (event.target);
      const opener = target.closest('[data-sh-open]');
      if (opener) {
        event.preventDefault();
        this.showSub(opener);
        return;
      }
      if (target.closest('[data-sh-back]')) {
        event.preventDefault();
        this.showMain(true);
      }
    }

    /** @param {Element} opener */
    showSub(opener) {
      const panel = this.querySelector(`#${opener.getAttribute('data-sh-open')}`);
      if (!panel) return;
      this.opener = opener;
      this.main.hidden = true;
      this.querySelectorAll('[data-sh-sub]').forEach((sub) => (sub.hidden = sub !== panel));
      opener.setAttribute('aria-expanded', 'true');
      this.scrollToTop();
      panel.querySelector('[data-sh-back]')?.focus({preventScroll: true});
    }

    /** @param {boolean} restoreFocus */
    showMain(restoreFocus) {
      this.querySelectorAll('[data-sh-sub]').forEach((sub) => (sub.hidden = true));
      this.querySelectorAll('[data-sh-open]').forEach((button) =>
        button.setAttribute('aria-expanded', 'false'),
      );
      this.main.hidden = false;
      this.scrollToTop();
      if (restoreFocus) this.opener?.focus({preventScroll: true});
    }

    scrollToTop() {
      const scroller = this.closest('.sh-menu-container');
      if (scroller) scroller.scrollTop = 0;
    }
  }

  customElements.define('sh-menu-drawer', ShMenuDrawer);
}
